__turbopack_context__.v({
  "action": "section-of-thumbnails-module-scss-module__r3M1lq__action",
  "card": "section-of-thumbnails-module-scss-module__r3M1lq__card",
  "centered": "section-of-thumbnails-module-scss-module__r3M1lq__centered",
  "copy-container": "section-of-thumbnails-module-scss-module__r3M1lq__copy-container",
  "heading": "section-of-thumbnails-module-scss-module__r3M1lq__heading",
  "outer": "section-of-thumbnails-module-scss-module__r3M1lq__outer",
  "row-with-heading": "section-of-thumbnails-module-scss-module__r3M1lq__row-with-heading",
  "thumbnail": "section-of-thumbnails-module-scss-module__r3M1lq__thumbnail",
});
